import "./App.css";
import "./tailwind.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faInstagram,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import packImage from "./imagens/pack.png";
import book1 from "./imagens/book1.png";
import book2 from "./imagens/book2.png";
import book3 from "./imagens/book3.png";
import book4 from "./imagens/book4.png";
import book5 from "./imagens/book5.png";
import book6 from "./imagens/book6.png";
import book7 from "./imagens/book7.png";
import book8 from "./imagens/book8.png";
import Slider from "react-slick";
import rogerio1 from "./imagens/rogerio1.png";
import rogerio2 from "./imagens/rogerio2.jpg";
import casal2 from "./imagens/casal2.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function App() {
  const setting = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const imageCarouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="container w-full py-8 mx-auto max-w-screen-2xl bg-gray-950">
      <div className="items-center justify-center ">
        <h2 className="m-4 mb-6 text-white text-md lg:text-2xl">
          PALESTRANTE, ESCRITOR E CONSULTOR
        </h2>
        <h1 className="w-40 ml-4 text-5xl font-bold text-white ">
          Rógerio Aguilar
        </h1>
        <p className="w-24 mt-8 ml-4 border-2 border-white"></p>
        <p className="mt-8 ml-4 mr-4 text-white text-md lg:text-xl">
          O pastor Rogério Aguilar é conhecido por sua profunda dedicação ao
          ensino e à pregação da Palavra de Deus. Sua trajetória de vida e
          carreira pastoral o transformaram em uma figura respeitada e influente
          na comunidade cristã.
        </p>
        <div className="flex justify-end mt-6 mr-4 text-3xl">
          <a
            href="https://www.facebook.com/share/18hy7A4kgP"
            target="_blank"
            rel="noreferrer"
            className="m-2 text-white rounded "
          >
            <FontAwesomeIcon icon={faFacebook} />
          </a>
          <a
            href="https://api.whatsapp.com/send?phone=5573999452311"
            target="_blank"
            rel="noreferrer"
            className="m-2 text-white rounded "
          >
            <FontAwesomeIcon icon={faWhatsapp} />
          </a>
          <a
            href="https://www.instagram.com/prrogerioaguilar"
            target="_blank"
            rel="noreferrer"
            className="m-2 text-white rounded "
          >
            <FontAwesomeIcon icon={faInstagram} />
          </a>
        </div>
        <div className="flex justify-center ml-4 xl:items-center">
          <img className="max-w-md-mx-auto" src={rogerio1} alt="roger" />
        </div>
      </div>
      <div className="flex flex-col items-center justify-center text-black bg-white text-md lg:text-xl ">
        <p className="items-center justify-center mt-10 ml-4 mr-4 ">
          Rogério Santos Aguilar, nasceu na cidade de Barueri, São Paulo, no dia
          04 de junho de 1974. Filho de Sebastião Pereira de Aguilar (in
          memoriam) e Erenice Santos de Aguilar (in memoriam). Casado com Vânia
          Mª Silva Barreiros Aguilar, pai de duas filhas, Alzira e Natália, e
          avô de três netos, Davi, Rafael e Henrique.
        </p>
        <p className="items-center justify-center mt-4 ml-4 mr-4">
          É o pastor da igreja de Deus reavivamento pentecostal (IDERP).
        </p>
        <p className="items-center justify-center mt-4 ml-4 mr-4">
          Reside em Teixeira de Freitas/BA com sua esposa Vânia, com suas duas
          filhas e suas três netos.
        </p>
        <div className="flex items-center justify-center w-64 mt-8 mb-8 border-2 rounded xl:w-1/2 border-amber-600 ">
          <img className="w-full max-w-md-mx-auto " src={casal2} alt="casal2" />
        </div>
      </div>

      <div className="flex flex-col text-white bg-gray-950">
        <h1 className="flex mt-8 ml-4 text-4xl font-bold text-white">
          Prêmios Conquistados
        </h1>
        <p className="mt-4 mb-8 ml-4 mr-4 text-md lg:text-xl">
          Desde que publicou seu primeiro livro em 2017, Rogério teve gratas
          surpresas ao ser indicado algumas vezes para o prêmio de melhor
          escritor do ano em sua cidade. Em várias dessas indicações foi
          considerado o melhor autor do ano na área de escritor religioso.
        </p>
        <div className="w-56 px-1 mt-2 mb-4 ml-16 xl:w-full xl:max-w-4xl xl:items-center xl:justify-center xl:mx-auto ">
          <Slider {...setting}>
            <div className="p-4 py-6 border ">
              <h3 className="mb-2 text-3xl italic">2022</h3>
              <p className="text-md lg:text-xl">
                Prêmio de melhor escritor do ano com o livro "Recomeços" em
                2022.
              </p>
            </div>
            <div className="p-4 py-6 border">
              <h3 className="mb-2 text-3xl italic">2023</h3>
              <p className="text-md lg:text-xl">
                Prêmio de melhor escritor do ano com o livro "Café com Bíblia"
                em 2023.
              </p>
            </div>
            <div className="p-4 py-6 border">
              <h3 className="mb-2 text-3xl italic">2024</h3>
              <p className="text-md lg:text-xl">
                Prêmio de melhor escritor do ano com o livro "Café com Bíblia"
                em 2024.
              </p>
            </div>
          </Slider>
        </div>
      </div>
      <div className="flex flex-col text-black bg-white text-md">
        <h1 className="flex mt-8 ml-4 text-4xl font-bold lg:text-5xl">
          Áreas de especialidade
        </h1>
        <h3 className="mt-10 mb-4 ml-4 text-2xl font-semibold ">LIDERANÇA</h3>
        <p className="ml-4 mr-4 text-md lg:text-xl">
          Atua há 30 anos no desenvolvimento de líderes que desejam executar uma
          visão de longo prazo e construir um legado duradouro através do modelo
          de liderança servidora, que guia e inspira sua equipe e comunidade
          através do exemplo.
        </p>
        <h3 className="mt-10 mb-4 ml-4 text-2xl font-semibold ">
          PLANEJAMENTO
        </h3>
        <p className="ml-4 mr-4 text-md lg:text-xl">
          Com sua experiência de mais de 30 anos em equipes pastorais e em
          cargos organizacionais, tem ajudando igrejas a alinhar visão e
          objetivos em planos de ação concretos, impulsionando o cumprimento da
          sua missão: fazer discípulos.
        </p>
        <h3 className="mt-10 mb-4 ml-4 text-2xl font-semibold">DISCIPULADO</h3>
        <p className="ml-4 mr-4 text-md lg:text-xl">
          Vive o discipulado um a um que conduz os seus membros em um processo
          estruturado de amadurecimento espiritual e multiplicação. Conduzido
          pela equipe de pastores, que já impactou muitas igrejas em todo o
          Brasil.
        </p>
        <h3 className="mt-10 mb-4 ml-4 text-2xl font-semibold ">
          ESTRATÉGIA E VISÃO
        </h3>
        <p className="ml-4 mr-4 text-md lg:text-xl">
          Um especialista em liderança enfatiza autenticidade e integridade,
          focando no desenvolvimento de líderes para impacto positivo e
          estratégico em comunidades. Com experiência em planejamento
          estratégico para igrejas e consultoria organizacional, busca promover
          crescimento sustentável e impacto duradouro.
        </p>
        <div className="flex w-64 mt-8 mb-8 xl:w-1/2 ml-14 xl:mx-auto">
          <img
            className="w-full max-w-md mx-auto border-2 rounded border-amber-600"
            src={rogerio2}
            alt="rogerio2"
          />
        </div>
      </div>

      <div className="flex flex-col text-white text-md lg:text-xl bg-gray-950">
        <h1 className="flex mt-8 ml-4 text-4xl font-bold lg:text-5xl">
          Livros
        </h1>
        <p className="mt-4 ml-4 mr-4">
          Autor de uma série de livros que se tornaram essenciais para líderes e
          pastores, especialmente dentro do contexto cristão. Suas obras, como
          “Café com bíblia” e “Inconstancia Espiritual”, oferecem uma combinação
          de teoria e prática, proporcionando orientações claras e acessíveis
          para líderes em diferentes estágios de sua jornada. Além de abordar
          temas como liderança servil e planejamento estratégico, Rogério
          Aguilar também explora questões de discipulado e formação de equipes,
          tornando seus livros recursos valiosos em treinamentos e seminários,
          tanto no Brasil quanto internacionalmente.
        </p>
        <button className="mt-14 ">
          <a
            href="https://hotmart.com/pt-br/club/rogerio-aguilar-books"
            target="_blank"
            rel="noreferrer"
            className="px-4 py-2 m-4 font-bold text-black bg-white border-2 rounded border-amber-600"
          >
            ADQUIRA SEUS LIVROS
          </a>
        </button>
        <div className="flex mt-8 mb-8 ml-8 w-80 xl:w-full xl:mx-full">
          <img
            className="w-full max-w-md mx-auto "
            src={packImage}
            alt="livros"
          />
        </div>
        <p className="w-full mt-2 border border-white "></p>
        <div className="px-1 mt-12 mb-4 ml-8 w-80 xl:w-1/2 xl:max-w-7xl xl:items-center xl:justify-center xl:mx-auto">
          <Slider {...imageCarouselSettings}>
            <div className="p-4 py-6 ">
              <img src={book1} alt="book1" className="w-full h-auto" />
            </div>
            <div>
              <img src={book2} alt="book2" className="w-full h-auto" />
            </div>
            <div>
              <img src={book3} alt="book3" className="w-full h-auto" />
            </div>
            <div>
              <img src={book4} alt="book4" className="w-full h-auto" />
            </div>
            <div>
              <img src={book5} alt="book5" className="w-full h-auto" />
            </div>
            <div>
              <img src={book6} alt="book6" className="w-full h-auto" />
            </div>
            <div>
              <img src={book7} alt="book7" className="w-full h-auto" />
            </div>
            <div>
              <img src={book8} alt="book8" className="w-full h-auto" />
            </div>
          </Slider>
          <button className="mt-2 mb-8 ml-8 xl:flex xl:mx-auto">
            <a
              href="https://go.hotmart.com/Q98778905X?dp=1"
              target="_blank"
              rel="noreferrer"
              className="px-4 py-2 m-4 font-bold text-white border-2 border-white rounded bg-amber-600"
            >
              ADQUIRA SEUS LIVROS
            </a>
          </button>
        </div>
      </div>
      <div>
        <div className="flex flex-col text-black bg-white text-md lg:text-xl">
          <h1 className="flex mt-8 ml-4 text-4xl font-bold">
            Contatos e Agendas
          </h1>
          <div className="flex justify-start mt-2 ml-3 mr-4 text-3xl">
            <a
              href="https://www.facebook.com/share/18hy7A4kgP"
              target="_blank"
              rel="noreferrer"
              className="m-2 text-black rounded "
            >
              <FontAwesomeIcon icon={faFacebook} />
            </a>
            <a
              href="https://api.whatsapp.com/send?phone=5573999452311"
              target="_blank"
              rel="noreferrer"
              className="m-2 text-black rounded "
            >
              <FontAwesomeIcon icon={faWhatsapp} />
            </a>
            <a
              href="https://www.instagram.com/prrogerioaguilar"
              target="_blank"
              rel="noreferrer"
              className="m-2 text-black rounded "
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a>
          </div>
          <p className="mt-4 mb-8 ml-4 mr-4">
            Entre em contato com Rogério Aguilar para agendar uma palestra,
            workshop ou consultoria. Envie um e-mail para{" "}
            <strong>prrogerioaguilar@gmail.com</strong>
          </p>
        </div>
      </div>
    </div>
  );
}

export default App;
